import BLE_UUID_TYPES from "../../consts/bleUuidTypes";
import BleService from "../ble/BleService";
import log from "../logger/logger";

let instances = {};

export default class FrameProcessingService {
    constructor(deviceId, createNew = false, characteristicUuid = BLE_UUID_TYPES.SCP_CONTROL_POINT) {
        let instance = instances[deviceId];
        if (instance && !createNew) {
            return instance;
        }

        if (instance) {
            instance.stop();
        }

        instance = this;
        instances[deviceId] = instance;
        this.state = {
            requests: [],
            responses: [],
        };
        this.deviceId = deviceId;

        this.characteristicUuid = characteristicUuid;

        this.characteristic = null;
        this.onResponse = this.onResponse.bind(this);

        this.timeout = null;
        this.start();
    }

    addFrameToQueue = ({ frame, timeout, onResponse, onError }) => {
        console.debug(`Added frame: ${frame}`);
        this.state.requests.push({ frame, timeout, onResponse, onError });
        this.writeFrame();
    };

    start = async () => {
        const bleService = new BleService();
        const bleClient = bleService.getDevice(this.deviceId);
        this.characteristic = await bleClient.getCharacteristic(
            BLE_UUID_TYPES.RRP_SERVICE,
            this.characteristicUuid
        );
        await this.characteristic.subscribeOnMessage(this.onResponse);
        this.active = true;
        this.writeFrame();
    };

    writeFrame = () => {
        if (!this.state.requests.length || !this.active) return;
        const { frame, timeout, onResponse, onError } = this.state.requests.shift();
        this.state.responses.push({ onResponse, onError });
        console.debug(`Write frame: ${frame}`);
        this.characteristic.writeValue(frame);
        this.runResponseTimeout(frame, timeout);
    };

    runResponseTimeout(frame, timeout = 5000) {
        this.timeout = setTimeout(() => {
            this.onResponseError(new Error(`[${this.deviceId}]. Process frame [${frame}] timeout`));
        }, timeout);
    }

    clearResponseTimeout() {
        clearTimeout(this.timeout);
    }

    onResponse(response) {
        if (response.data?.errorCode) {
            this.onResponseError(response.data?.errorCode);
            return;
        }
        const frame = response.data?.data;
        this.clearResponseTimeout();
        if (!this.state.responses.length) return;
        const state = this.state.responses.shift();
        const { onResponse } = state;

        onResponse(frame);
        this.writeFrame();
    }

    onResponseError(error) {
        log.error(`onResponseError`, error);
        if (!this.state.responses.length) return;
        const state = this.state.responses.shift();
        const { onError } = state;
        onError(error);
        this.writeFrame();
    }

    stop() {
        this.state.requests = [];
        this.state.responses = [];
        this.clearResponseTimeout();
        this.active = false;
        instances[this.deviceId] = null;
        this.characteristic?.unsubscribeOnMessage(this.onResponse);        
    }
}
